
import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'

@Component({
  components: {
  },
  filters:{}
})
export default class Test extends Vue {

  @Prop({ default: '64px' }) private size!: string
  @Prop({ default: '#FFFFFF' }) private color!: string
  
  private get diamondStyle(): any {
    let size = parseInt(this.size)
    return {
        width: size / 4 + 'px',
        height: size / 4 + 'px',
        '--bg-color': this.color
    }
  }
  private get styles(): any {
    let size = parseInt(this.size)
    return {
        width: this.size,
        height: size / 4 + 'px'
    }
  }
}
